import React from 'react';

/**
 * Theme-aware System Health sidebar icon based on the supplied pulse mark.
 *
 * @returns {JSX.Element} System Health icon
 */
const SidebarSystemHealthIcon = () => (
    <svg
        aria-hidden="true"
        focusable="false"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <ellipse
            cx="12"
            cy="12"
            rx="10"
            ry="10"
            stroke="currentColor"
            strokeWidth="1.5"
        />
        <polyline
            points="4.8,12.4 8.2,12.4 9.5,9.8 11.3,15.3 13.6,7.5 15.5,13.9 17,11.2 18.5,12.4 19.5,12.4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default SidebarSystemHealthIcon;
